import { render } from "./Company.vue?vue&type=template&id=b5ff37c4"
import script from "@/assets/directoryJs/Company.js?vue&type=script&lang=js"
export * from "@/assets/directoryJs/Company.js?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__